import { createTranslations } from '@npco/utils-translations'

export const setupFlowAccountsStageTranslations = createTranslations({
  badge: 'Accounts',
  title: 'Replace your outdated business bank accounts.',
  transactionAccount: 'Zeller Transaction Account',
  point1: 'Receive fast payment settlements, 7 days a week.',
  point2: 'Real-time fund transfers.',
  point3: 'Create multiple accounts for teams or projects.',
  savingAccount: 'Zeller Savings Account',
  point4WithoutInterest: 'A great interest rate.',
  point4WithInterest: 'A great interest rate of up to {interest}% p.a.*',
  point5: 'Ready to go, activate in seconds.',
  point6: 'Access your funds instantly.',
  checkboxMessage: 'Link a Debit Card to this Account',
  errorMessage: 'Card creation was unsuccessful. Please try again later.',
  termsApply: '* Terms apply',
})
